
import React from 'react'

class MenuButton extends React.Component{

    render () {
        return <svg
            onClick={this.props.callback}
            height="128pt"
            viewBox="0,0,128,128"
            style= {{
                cursor: 'pointer',
                width: 48,
                height: 48,
                float: 'left',
                position: 'absolute',
                top: 0,
                left: 0,
                stroke: '#343434',
            }}>
            <path d="M32+37.0299L96+37.0299"  strokeWidth="10" fill="none" opacity="1"/>
            <path d="M32+91.1721L96+91.1721" strokeWidth="10" fill="none" opacity="1"/>
            <path d="M32+64L96+64" strokeWidth="10" fill="none" opacity="1"/>
        </svg>
  }
}

export default MenuButton